define('utils',[],function() {
    'use strict';

    var Utils = function() {

        var player = document.getElementById('player'),

        escapeHTML = function(str) {
            var res = '',
                len = str.length,
                to = 0;

            for (var i=0; i < len ; i++) {
                var ref,
                    code = str.charCodeAt(i);

                if (code > 62) {
                    continue;
                } else if (code === 38) {
                    ref = "&amp;";
                } else if (code === 34) {
                    ref = "&#34;";
                } else if (code === 39) {
                    ref = "&#39;";
                } else if (code === 60) {
                    ref = "&lt;";
                } else if(code === 62) {
                    ref = "&gt;";
                } else {
                    continue;
                }

                res += to === i ? ref : str.substring(to, i) + ref;

                to = i + 1;
            }

            if (to !== len) {
                res += str.substring(to, len);
            }

            return res;
        },

        getLayout = function() {
            if (!player) {
                return '';
            }

            return window.getComputedStyle(player, ':after').getPropertyValue('content').replace(/"/g, '');
        },

        isNumber = function(arg) {

            return !isNaN(parseFloat(arg)) && isFinite(arg);
        },

        isFunction = function(fn) {
            var getType = {};

            return fn && getType.toString.call(fn) === '[object Function]';
        },

        isObject = function(o) {
            return (!!o) && (o.constructor === Object);
        },

        isBrowserMS = function() {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                return true;
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                return true;
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                return true;
            }

            return false;
        },

        isOldIE = (function() {

            return document.all && !window.atob;
        })(),

        JSON = function() {

            return ( window.JSON && window.JSON.parse && window.JSON.stringify ) ? true : false;
        },

        localStorageSpace = function() { // return localStorage space in KB
            var key,
                str = '';

            for (key in window.localStorage) {
                if (window.localStorage.hasOwnProperty(key)) {
                    str += window.localStorage[key];
                }
            }

            return str ? 3 + ((str.length*16)/(8*1024)) : 0;
        },

        isTouchDevice = (function() {
            if (Modernizr.touchevents) {
                return true;
            }

            if (window.navigator.msMaxTouchPoints > 0 || window.navigator.maxTouchPoints > 0) {
                var root = document.documentElement;

                root.classList.remove('no-touchevents');
                root.classList.add('touchevents');

                return true;
            }

            return false;
        })(),

        onLine = function() {

            return (window.navigator.onLine) ? true : false;
        };

        return {
            escapeHTML: escapeHTML,
            getLayout: getLayout,
            isNumber: isNumber,
            isFunction: isFunction,
            isObject: isObject,
            isBrowserMS: isBrowserMS,
            isOldIE: isOldIE,
            isTouchDevice: isTouchDevice,
            JSON: JSON,
            localStorageSpace: localStorageSpace,
            onLine: onLine
        };

    };

    return new Utils();

});

